import { render, staticRenderFns } from "./add-new-column-dialog.vue?vue&type=template&id=5a94b739&scoped=true&"
import script from "./add-new-column-dialog.vue?vue&type=script&lang=ts&"
export * from "./add-new-column-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./add-new-column-dialog.vue?vue&type=style&index=0&id=5a94b739&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a94b739",
  null
  
)

export default component.exports